import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Tabs,
  Tab
} from "@material-ui/core";
import AgGridWrapper from "./AgGridWrapper";
import DownloadMenu from "./DownloadMenu";

const downloadWarningText =
  "This tool is a work in progress and at this point the output datasets have not been fully checked for errors in the data integration or data values. Please speak with the appropriate staff scientist before using the data, particularly before publishing.";

const TableCard = props => {
  const showHideColumnPickerLabel = props.showGridColumnPicker
    ? "Hide column picker"
    : "Show column picker";

  return (
    <Card>
      <Dialog
        open={props.downloadModalVisible}
        onRequestClose={() => props.downloadModalSetVisible(false)}
        title="Disclaimer"
      >
        {" "}
        <DialogTitle>Disclaimer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are about to download <b>{props.recordCount}</b> records.
            <br />
            <br />
            {downloadWarningText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            primary
            onClick={() => {
              props.actions.fetchDownloader(props.downloadFileType);
              props.downloadModalSetVisible(false);
            }}
          >
            Download
          </Button>
          ,
          <Button primary onClick={() => props.downloadModalSetVisible(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <CardHeader
        title={
          <Tabs
            value={props.tabValue}
            onChange={props.handleTabChange}
            aria-label="Download Tabs"
          >
            <Tab label="Table" />
            <Tab label="Map" />
            <Tab label="Chart" />
          </Tabs>
        }
        action={
          props.sample.display_name.length ? (
            <span>
              <Button
                variant="contained"
                disabled={!props.gridIsLoaded}
                onClick={() => {
                  props.actions.toggleColumnPicker();
                  setTimeout(() => props.gridRef.api.sizeColumnsToFit(), 200);
                }}
                style={{
                  boxShadow:
                    "0px 1px 5px 0px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 3px 1px -2px rgb(0 0 0 / 12%)",
                  marginRight: "10px"
                }}
              >
                {showHideColumnPickerLabel}
              </Button>
              <DownloadMenu {...props} />
            </span>
          ) : null
        }
      />

      <CardContent>
        <Row style={{ marginTop: "1rem" }}>
          <Col xs={12}>
            {(props.filterChanged || !props.showPreview) && (
              <Typography style={{ margin: "5px" }}>
                <b>
                  {/* eslint-disable-next-line react/no-unescaped-entities */}
                  Click 'LOAD PREVIEW' to refresh data in the table below to
                  match your search criteria.
                </b>
              </Typography>
            )}
            {props.showPreview ? <AgGridWrapper {...props} /> : null}
          </Col>
        </Row>
      </CardContent>
    </Card>
  );
};

TableCard.defaultProps = {
  gridRef: {}
};
TableCard.propTypes = {
  downloadFileType: PropTypes.string.isRequired,
  downloadModalVisible: PropTypes.bool.isRequired,
  downloadModalSetVisible: PropTypes.func.isRequired,
  isFetchingFile: PropTypes.bool.isRequired,
  gridIsLoaded: PropTypes.bool.isRequired,
  showPreview: PropTypes.bool.isRequired,
  filterChanged: PropTypes.bool.isRequired,
  isFetchingRecordCount: PropTypes.bool.isRequired,
  showGridColumnPicker: PropTypes.bool.isRequired,
  downloadRawHeaders: PropTypes.bool.isRequired,
  // eslint-disable-next-line
  gridRef: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  sample: PropTypes.shape({ display_name: PropTypes.string }).isRequired,
  actions: PropTypes.shape({
    toggleColumnPicker: PropTypes.func.isRequired,
    fetchDownloader: PropTypes.func.isRequired,
    rawHeadersOnChange: PropTypes.func.isRequired
  }).isRequired,
  recordCount: PropTypes.number.isRequired,
  tabValue: PropTypes.number.isRequired,
  handleTabChange: PropTypes.func.isRequired
};

export default TableCard;
